<app-intake-header [viewModel_]="viewModels_().$intakeHeaderViewModel" />

<div class="flex h-[calc(100%-69px)]">
	<div class="w-[calc(411px+2rem)] border-r">
		<div class="flex flex-col h-full">
			<div class="py-3 px-4 border-b">
				<ui-button-segmented
					[selectedId]="formMode_()"
					(selectedIdChange)="changeFormMode($event)"
					[options]="[
						{
							id: IntakeFormMode.PREVIEW,
							label: 'Preview',
							icon: 'eye',
						},
						{
							id: IntakeFormMode.EDIT,
							label: 'Edit Form',
							icon: 'pencil',
						},
					]"
					class="w-full"
					[testHook]="testHooks.ButtonSegmented"
				></ui-button-segmented>
			</div>
			<div class="grow">
				<app-intake-side-panel />
			</div>
		</div>
	</div>
	<div class="grow">
		<div class="flex flex-col h-full">
			<div class="min-h-[63px]">
				<h3 class="pl-4 pt-4 text-lg font-medium">Preview Form</h3>
			</div>
			<div class="-mt-[1px] grow bg-gray-50 overflow-y-auto">
				<app-intake-form-preview />
			</div>
		</div>
	</div>
</div>
